<template>
  <div class="m-edition-section-content-info-submenu m-edition-section-content-info-submenu-map">
    <ul>
      <li>
        <router-link
          :class="[$t('mEditionMenu.map.enrollments.subject') === $route.params.subject
            && ($t('mEditionMenu.map.enrollments.children.students.subedition') === $route.params.subedition
              || $t('mEditionMenu.map.enrollments.children.contents.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-map'
              : '']"
          :to="`/${$t('rPaths.map')}/${this.$route.params.id}/${$t('mEditionMenu.map.enrollments.subject')}/${$t('mEditionMenu.map.enrollments.children.students.subedition')}`"
        >
          {{ $t('mEditionMenu.map.enrollments.children.students.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.map.enrollments.subject') === $route.params.subject
            && ($t('mEditionMenu.map.enrollments.children.families.subedition') === $route.params.subedition
              || $t('mEditionMenu.map.enrollments.children.familyMembers.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-map'
              : '']"
          :to="`/${$t('rPaths.map')}/${this.$route.params.id}/${$t('mEditionMenu.map.enrollments.subject')}/${$t('mEditionMenu.map.enrollments.children.families.subedition')}`"
        >
          {{ $t('mEditionMenu.map.enrollments.children.families.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.map.enrollments.subject') === $route.params.subject
            && ($t('mEditionMenu.map.enrollments.children.invitations.subedition') === $route.params.subedition
              || $t('mEditionMenu.map.enrollments.children.invitations.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-map'
              : '']"
          :to="`/${$t('rPaths.map')}/${this.$route.params.id}/${$t('mEditionMenu.map.enrollments.subject')}/${$t('mEditionMenu.map.enrollments.children.invitations.subedition')}`"
        >
          {{ $t('mEditionMenu.map.enrollments.children.invitations.subText') }}
        </router-link>
      </li>
      <li>
        <router-link
         :class="[$t('mEditionMenu.map.enrollments.subject') === $route.params.subject
            && ($t('mEditionMenu.map.enrollments.children.statics.subedition') === $route.params.subedition
              || $t('mEditionMenu.map.enrollments.children.statics.subedition') === $route.params.subedition)
              ? 'submenu-item-active submenu-item-active-map'
              : '']"
          :to="`/${$t('rPaths.map')}/${this.$route.params.id}/${$t('mEditionMenu.map.enrollments.subject')}/${$t('mEditionMenu.map.enrollments.children.statics.subedition')}`"
        >
          {{ $t('mEditionMenu.map.enrollments.children.statics.subText') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapEnrollmentsSubMenu'
}
</script>
